import React, { useState } from "react";
import { del, get, post } from "../../../../utils/api";
import { LIKE_TYPES } from "../../../../utils/constants";
import { toast } from "react-hot-toast";
import { useAppSelector } from "../../../../store";
import { useLikes } from "../../../../store/LikeContext";

const LIKE_CONFIGS = {
  TRACKS: { endpoint: "/track-like", param: "tracks__id", field: "tracks", key: "TRACKS" },
  TRACK: { endpoint: "/track-like", param: "tracks__id", field: "tracks", key: "TRACKS" },
  ANNOUNCEMENT: { endpoint: "/announcement-like", param: "announcement__id", field: "announcement", key: "ANNOUNCEMENT" },
  ANNOUNCEMENTS: { endpoint: "/announcement-like", param: "announcement__id", field: "announcement", key: "ANNOUNCEMENT" },
  STUDIO: { endpoint: "/studio-like", param: "studio__id", field: "studio", key: "STUDIO" },
  STUDIOS: { endpoint: "/studio-like", param: "studio__id", field: "studio", key: "STUDIO" },
  NEWS: { endpoint: "/news-like", param: "news__id", field: "news", key: "NEWS" },
  PRODUCTS: { endpoint: "/product-like", param: "products__id", field: "products", key: "PRODUCTS" },
  PRODUCT: { endpoint: "/product-like", param: "products__id", field: "products", key: "PRODUCTS" },
};

const getConfig = (t) => {
  const upper = String(t || "").toUpperCase();
  return (
    LIKE_CONFIGS[upper] || {
      endpoint: LIKE_TYPES[upper] || `/${String(t).toLowerCase()}-like`,
      param: `${String(t).toLowerCase()}__id`,
      field: String(t).toLowerCase(),
      key: upper,
    }
  );
};

const LikeButton = ({ id, type, onClick = null }) => {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const { isLiked, addLike, removeLike } = useLikes();
  const [loading, setLoading] = useState(false);
  const [likeRecordId, setLikeRecordId] = useState(null);

  const cfg = getConfig(type);
  const liked = isLiked(cfg.key, id);

  const postData = async () => {
    if (!currentUser?.id) {
      toast.error("Beğenmek için lütfen giriş yapın.");
      return;
    }
    setLoading(true);
    try {
      const numId = Number(id);
      const result = await post(`${cfg.endpoint}/`, {
        user: currentUser.id,
        [cfg.field]: numId,
      });

      const status = result?.status;
      const isSuccess = status >= 200 && status < 300;
      const alreadyLiked =
        status === 400 &&
        typeof result?.data?.detail === "string" &&
        (result.data.detail.toLowerCase().includes("zaten") ||
          result.data.detail.toLowerCase().includes("already"));

      if (isSuccess || alreadyLiked) {
        toast.success("Beğendim");
        addLike(cfg.key, numId);
      } else {
        toast.error(result?.data?.detail || "Hata :(");
      }
    } catch (e) {
      toast.error("Hata :(");
    } finally {
      setLoading(false);
    }
  };

  const unLike = async () => {
    if (!currentUser?.id) {
      toast.error("Lütfen giriş yapın.");
      return;
    }
    setLoading(true);
    try {
      const numId = Number(id);
      let recordId = likeRecordId;

      if (!recordId) {
        try {
          const res = await get(
            `${cfg.endpoint}/?user__id=${currentUser.id}&${cfg.param}=${numId}`
          );
          const list = Array.isArray(res) ? res : res?.results || [];
          if (list.length > 0) {
            recordId = list[0].id;
          } else if (currentUser?.dj_user_id) {
            const res2 = await get(
              `${cfg.endpoint}/?user__id=${currentUser.dj_user_id}&${cfg.param}=${numId}`
            );
            const list2 = Array.isArray(res2) ? res2 : res2?.results || [];
            if (list2.length > 0) {
              recordId = list2[0].id;
            }
          }
        } catch (fetchErr) {
          console.warn("Beğeni kaydı arama uyarısı:", fetchErr);
        }
      }

      if (recordId) {
        try {
          await del(cfg.endpoint, recordId);
        } catch (deleteErr) {
          console.warn("Beğeni silme isteği uyarısı:", deleteErr);
        }
      }

      // Kullanıcı deneyimi açısından yerel durumu her zaman başarıyla güncelle
      toast.success("Beğenmekten vazgeçtim");
      removeLike(cfg.key, numId);
      setLikeRecordId(null);
    } catch (e) {
      // Beklenmedik hata olsa dahi yerel durumu temizle, kullanıcı kilitlenmesin
      removeLike(cfg.key, Number(id));
      toast.success("Beğenmekten vazgeçtim");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (loading) return;
    if (liked) {
      await unLike();
    } else {
      await postData();
    }
    if (onClick) onClick();
  };

  return (
    <a role="button"
      onClick={handleSubmit}
      className="btn-favorite"
      style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
      title={liked ? "Beğenmekten vazgeç" : "Beğen"}
    >
      {liked ? (
        <i className="fa fa-heart" style={{ color: "#e11d48" }}></i>
      ) : (
        <i className="fa fa-heart-o"></i>
      )}
    </a>
  );
};

export default LikeButton;
